import { useEffect, useMemo, useRef } from 'react';
import _ from 'lodash';
import Router from './routes';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
//reducers
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectLanguage, getLoadingLanguage } from 'state/reducers/translation.reducers';
import { login, getUserPermission, getTerms } from 'state/reducers/user.reducers';
//MUI
import { Box } from '@mui/system';
import ThemeProvider from './theme';
import 'theme/fonts.css';
//compnents
import AssetsProvider from 'pages/AssetsProvider';
import WaitingMessage from 'components/WaitingMessage';
import { getPage } from 'state/reducers/ui.reducers';
import { getBalancesByCompanyId } from 'services/balance.services';
import { getAllSystemSettings } from 'services/system_settings.services';

import Chat from './components/Chat';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';

function App() {
	const dispatch = useAppDispatch();
	const { accounts } = useMsal();
	const loginAccountIdRef = useRef<string>();
	const lang = useAppSelector(selectLanguage);
	const userPermission = useAppSelector(getUserPermission);
	const loadingLanguage = useAppSelector(getLoadingLanguage);
	const dir = useMemo(() => (_.includes(lang, 'he') ? 'rtl' : 'ltr'), [lang]);

	const page = useAppSelector(getPage);

	useEffect(() => {
		if (userPermission && userPermission !== 'None') {
			dispatch(getBalancesByCompanyId());
			dispatch(getAllSystemSettings());
		}
	}, [userPermission]);

	useEffect(() => {
		if (!_.isEmpty(accounts)) {
			const accountId =
				accounts[0]?.homeAccountId ||
				accounts[0]?.localAccountId ||
				accounts[0]?.idTokenClaims?.oid ||
				accounts[0]?.username;
			if (loginAccountIdRef.current === accountId) {
				return;
			}

			loginAccountIdRef.current = accountId;
			dispatch(login(accounts));
		}
	}, [accounts]);

	return (
		<MsalAuthenticationTemplate interactionType={InteractionType.Redirect} loadingComponent={() => <WaitingMessage />}>
			<ThemeProvider dir={dir}>
				<AssetsProvider loadingLanguage={loadingLanguage} userPermission={userPermission}>
					<FeatureFlagProvider>
						<Box dir={dir}>
							{<Router permission={userPermission} />}
							{!_.isEmpty(accounts) && userPermission && userPermission !== 'None' && <Chat />}
						</Box>
					</FeatureFlagProvider>
				</AssetsProvider>
			</ThemeProvider>
		</MsalAuthenticationTemplate>
	);
}

export default App;
